/** @jsxImportSource @emotion/react */
import createContextFetchLoader from '../contextFetch/Loader'
import TenantThemeContext from './Context'
import useTenantTheme from './index'
import { TenantThemeType, UseTenantThemePropsType } from './types'

export const TenantThemeLoader = createContextFetchLoader<
  TenantThemeType,
  UseTenantThemePropsType
>({
  fetchHook: useTenantTheme,
  FetchContext: TenantThemeContext
})

export default TenantThemeLoader
